'use client';

import { ApolloProvider as BaseApolloProvider } from '@apollo/client';
import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';

import { SensitiveActionConfirmationProvider } from '@/components/auth/SensitiveActionConfirmationProvider';
import { createApolloClient, setBrowserApolloAccessTokenOverride } from '@/lib/apollo/client';

type ApolloProviderClientProps = {
  accessToken?: string;
  children: React.ReactNode;
  organisationId?: string;
};

export const ApolloProviderClient: React.FC<ApolloProviderClientProps> = ({
  accessToken = '',
  children,
  organisationId = '',
}) => {
  const { data: session } = useSession();
  const effectiveAccessToken = session?.accessToken ?? accessToken;
  const [client, setClient] = useState(() => createApolloClient({ accessToken: effectiveAccessToken, organisationId }));

  useEffect(() => {
    setBrowserApolloAccessTokenOverride(session?.accessToken);
    setClient(createApolloClient({ accessToken: effectiveAccessToken, organisationId }));
  }, [effectiveAccessToken, organisationId, session?.accessToken]);

  return (
    <BaseApolloProvider client={client}>
      <SensitiveActionConfirmationProvider>{children}</SensitiveActionConfirmationProvider>
    </BaseApolloProvider>
  );
};
